import {
  PropsOf,
  chakra,
  forwardRef,
  omitThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import {
  AdmonitionProvider,
  AdmonitionStylesProvider,
  AdmonitionVariant,
} from './Admonition.context';

export interface AdmonitionProps extends PropsOf<'div'> {
  variant: AdmonitionVariant;
  children: React.ReactNode;
}

export const Admonition = forwardRef<AdmonitionProps, 'div'>((props, ref) => {
  const { variant } = props;
  const styles = useMultiStyleConfig('Admonition', props);
  const { className, children, ...rest } = omitThemingProps(props);
  return (
    <AdmonitionProvider value={variant}>
      <AdmonitionStylesProvider value={styles}>
        <chakra.div
          __css={styles.container}
          ref={ref}
          {...rest}
          // eslint-disable-next-line tailwindcss/no-custom-classname
          className={classnames('orbit-admonition', className)}
        >
          {children}
        </chakra.div>
      </AdmonitionStylesProvider>
    </AdmonitionProvider>
  );
});
